export default "__VITE_ASSET__BUTcZJTA__"